// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-container {
  display: flex;
  flex-direction: row-reverse;
  gap: 10px;
}
@media screen and (max-width: 690px) {
  .btn-container {
    flex-direction: column;
  }
}
.btn-container button {
  min-width: 180px;
}

form {
  width: 100%;
}
form .form-control {
  font-size: 14px;
}

.form-row {
  display: flex;
  align-items: center;
}
.form-row .row-name-container {
  font-size: 110%;
  margin-left: 15px;
  margin-bottom: -5px;
  margin-top: 20px;
}
.form-row .input-container.not-loaded {
  opacity: 0.6;
  pointer-events: none;
}

.label-container,
.field-container {
  padding: 10px;
}

.label-container {
  flex: 1;
  max-width: 200px;
  text-align: right;
  font-size: 14px;
  padding-top: 15px;
}

.field-container {
  flex: 3;
  max-width: 500px;
  font-size: 14px;
  position: relative;
}
.field-container.horizontal-centered {
  display: flex;
  align-items: flex-end;
}
.field-container.hover-pointer *:hover {
  cursor: pointer;
}
.field-container.selected-company-row {
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  align-items: center;
}
.field-container.selected-company-row .thumbnail-img {
  width: 60px;
}
.field-container.selected-company-row .icon-close {
  width: 18px;
  height: 18px;
  position: relative;
  top: -2px;
}
.field-container.selected-company-row .icon-close:hover {
  cursor: pointer;
}
.field-container.selected-company-row .company-name span {
  display: block;
}
.field-container .file-input-error {
  font-weight: 700;
  font-size: 14px;
  margin-top: 10px;
  color: red;
}
.field-container .allowed-file-types {
  font-size: 12px;
  font-style: italic;
  margin-top: 10px;
}
.field-container .dropdown-menu.dropdown-search-result.absolute {
  margin-top: 0;
  margin-left: 0;
  max-height: 300px;
  overflow-y: auto;
  width: 100%;
}
.field-container .dropdown-menu.dropdown-search-result.absolute .dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.field-container .dropdown-menu.dropdown-search-result.absolute .dropdown-item img {
  width: 50px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
